function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import anime from 'animejs';
var waveEffectSelector = '.js-anime-wave-effect';
var searchFormSelector = '.js-anime-search-form';
var transition = {
  duration: 800,
  easing: 'easeInOutCirc'
};
export var enterAnimation = function enterAnimation() {
  var timeline = anime.timeline(transition);
  var waveEffectForward = {
    targets: waveEffectSelector,
    scale: 50
  };
  var formEffectForward = {
    targets: searchFormSelector,
    opacity: [0, 1],
    duration: 100
  };
  timeline.add(waveEffectForward).add(formEffectForward, '-=400');
};
export var exitAnimation = function exitAnimation(config) {
  if (config === void 0) {
    config = {};
  }

  var timeline = anime.timeline(_extends({}, transition, config));
  var waveEffectBackward = {
    targets: waveEffectSelector,
    scale: 1
  };
  var formEffectBackward = {
    targets: searchFormSelector,
    opacity: [1, 0],
    duration: 100
  };
  timeline.add(formEffectBackward).add(waveEffectBackward, '-=200');
};
export var enterWithoutAnimation = function enterWithoutAnimation() {
  document.querySelector(searchFormSelector).style.opacity = 1;
  document.querySelector(waveEffectSelector).style.transform = 'scale(50)';
};
export var exitWithoutAnimation = function exitWithoutAnimation() {
  document.querySelector(searchFormSelector).style.opacity = 0;
  document.querySelector(waveEffectSelector).style.transform = 'scale(1)';
};